export const RoomLayoutMapStrings = {
  ERROR_FALLBACK_MESSAGE: 'Please try again later.',
  ERROR_TITLE_LAYOUT_UNAVAILABLE: 'Layout unavailable',
  ERROR_MESSAGE_NOT_FOUND: 'This layout could not be found.',
  ERROR_MESSAGE_LAYOUT_INACTIVE: 'Booking is available without spot selection.',
  ERROR_TITLE_NETWORK: 'Network error',
  ERROR_MESSAGE_CHECK_CONNECTION: 'Check your connection and try again.',
  ERROR_TITLE_SOMETHING_WRONG: 'Something went wrong',
  LOADING_LAYOUT: 'Loading layout data...'
} as const;
